<template>
  <div class="container pt-4">
    <h1 style="text-align: center">Ubytování</h1>
    <div class="row pt-4">
      <div class="col-12 mb-3">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Ubytování</h2>
            <p>
              Penzion prošel v nedávné době zásadní rekonstrukcí. Byla zhotovena nová střecha, zateplení a fasáda. Ke změnám došlo i v interiérech a
              pokojích, kde byly položeny nové podlahy, nové postele byly vybaveny kvalitními matracemi. Nově je vybudované i sociální zařízení (WC a
              koupelna). Rekonstrukcí prošla i kuchyňka, kde byla rovněž položena nová podlaha a osazena moderní kuchyňská linka.
            </p>
            <p>
              V penzionu je k dispozici apartmán, který tvoří dvoulůžkový a čtyřlůžkový mezonetový pokoj. Oba pokoje jsou mimo jiné vybaveny
              miniknihovnou a televizorem. Oba mají také možnost přistýlky. Hostům jsou k dispozici informační letáky, brožury a další literatura s
              turistickou šumavskou tématikou. Součástí apartmánu je zmiňované nově vybudované sociální zařízení a kuchyňka vybavená pro přípravu a
              konzumaci jídla (příbory a nádobí, lednice, sporák, mikrovlnná trouba, rychlovarná konvice).
            </p>
            <p>
              V apartmánu je možnost posezení uvnitř i na balkóně. Na balkon je přístup z kuchyňky a nabízí krásnou vyhlídku do údolí i na hraniční
              šumavské hory.
            </p>
            <p>
              U penzionu je hostům k dispozici zahrada a venkovní sezení s možností grilování nebo opékání buřtů.
              Za poplatek lze poskytnout dřevo, k dispozici je grilovací náčiní i vidlice na opékání buřtů. Nádobí z kuchyňky lze používat i venku. U
              ohně je možné strávit příjemný večer i bez grilování, jen tak se skleničkou piva či vína.
            </p>
            <p>
              U penzionu je nezpoplatněné soukromé parkoviště.
            </p>
            <p>
              Hosté mohou využívat i zatravněný pozemek u penzionu, například k hraní her jako je petangue nebo badminton (obojí je možné si v
              penzionu zdarma zapůjčit).
            </p>
            <div class="row">
              <div
                  class="col-md-4 pb-3"
                  v-for="(image, i) in images_accomodation"
                  :key="i"
              >
                <div class="card h-100">
                  <div>
                    <img
                        class="card-img-top"
                        style="object-fit: cover; height: 300px;"
                        :src="image.url"
                        :alt="image.alt"
                        @click="index = i"
                    />
                  </div>

                  <div class="card-body">
                    <p
                        class="card-text"
                        style="text-align: center; font-style: italic"
                    >
                      {{ image.alt }}
                    </p>
                  </div>
                </div>
              </div>
              <vue-gallery-slideshow
                  :images="images_accomodation"
                  :index="index"
                  @close="index = null"
              ></vue-gallery-slideshow>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Stravování</h2>
            <p>
              V našem penzionu se nevaří. Hosté mohou k přípravě jídel využít kuchyňku, případně navštívit některou ze tří restaurací nacházejících se v bezprostřední blízkosti penzionu. Na hotelu Kristián (100 m od penzionu) jsou podávány i snídaně formou teplého a studeného bufetu.
            </p>
            <p>
              Prodejna potravin v obci není. Nejbližší jsou v obci Horní Vltavice (Coop) asi 4 km od Kubovi Hutě a ve Vimperku (Lidl, Penny, Coop nebo Tesco) 10 km od KH. Na tuto skutečnost upozorňujeme především hosty, kteří k nám dorazí vlakem.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Turistické a sportovní vyžití</h2>
            <p>
              V okolí penzionu je množství atraktivních tras pro pěší i cyklisty - Boubín, Plechý, Třístoličník a mnoho dalších. V létě je možnost
              sjet na lodi nedalekou Vltavu z obce Lenora až do Nové Pece. Hosté mohou pro inspiraci k výletům nahlédnout do oficiální krásně vyvedené
              publikace Správy národního parku Šumava. </p>
            <p>
              V létě a na podzim lze využít okolních šumavských lesů k houbaření nebo sběru borůvek a malin.
            </p>
            <p>
              Poblíž obce se nachází lyžařský běžecký areál, kde jsou v zimním období pravidelně udržovány stopy na několika okruzích v délkách od 2
              do 15 km. Z areálu je možnost napojit se na běžeckou magistrálu Strážný - Železná Ruda.
            </p>
            <p>
              Přímo v obci jsou dvě sjezdovky (Pod Obrovcem a Školní) s lyžařskými vleky o délkách 500 a 250 m. Především ta druhá je díky své
              nenáročnosti vhodná pro děti a jejich základní lyžařskou výuku.
            </p>
            <p>
              Funguje zde i lyžařská škola.
            </p>
            <p>
              Náročnější lyžaři mohou využít 16 km vzdáleného zimního lyžařského střediska v německém Mitterdorfu.
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  name: "accommodation",
  components: {
    VueGallerySlideshow,
  },
  data: function() {
    return {
      images_accomodation: [
        {
          url: require("@/assets/galerie/dvojluzkovy_pokoj_1.jpg"),
          alt: "Dvojlůžkový pokoj",
        },
        {
          url: require("@/assets/galerie/dvojluzkovy_pokoj_2.jpg"),
          alt: "Dvojlůžkový pokoj - postele",
        },
        {
          url: require("@/assets/galerie/podkrovni_pokoj_1.jpg"),
          alt: "Podkrovní pokoj",
        }
      ],
      index: null,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
